module.exports = function(ngModule) {
  console.log('Hallo home');
  ngModule.config(['$stateProvider', function($stateProvider) {
    $stateProvider.state('home', {
      url: '/home',
      controller: require('./controller.js'),
      controllerAs: 'vm'
    });
  }]);
};
